// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":focus {\n  outline: none !important;\n}\n\n[data-testid=\"toggleUser\"] > div:nth-child(2) {\n  background-color: var(--brand-color) !important;\n}\n\n/* required to hide previous stack screens in tests */\n[aria-hidden=\"true\"] {\n  visibility: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
